"use client";

import { mergeProps } from "@react-aria/utils";
import type { HTMLAttributes } from "react";

import { cn } from "../../utils";
import { useTextFieldRootContext } from "./context";

export type TextFieldDescriptionProps = HTMLAttributes<HTMLSpanElement>;

const Description = (props: TextFieldDescriptionProps) => {
  const { textField } = useTextFieldRootContext();
  const mergedProps = mergeProps(props, textField?.descriptionProps);

  return <span {...mergedProps} className={cn("text-sm text-neutral-50", mergedProps.className)} />;
};

export default Description;
